'use client';

import { useSessionMonitor } from '@/hooks/useSessionMonitor';

export function SessionMonitorProvider({ children }: { children: React.ReactNode }) {
  useSessionMonitor();
  return <>{children}</>;
}
